/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('[data-popup-close]');

    if (closeBtn) {
      e.preventDefault();

      const dialog = closeBtn.closest('dialog');

      if (dialog) {
        dialog.close();
        dialog.removeAttribute('open');
        dialog.setAttribute('aria-hidden', 'true');

        // ✅ custom close state
        dialog.setAttribute('data-state', 'closed');
      }
    }
  });
})();